export default "__VITE_ASSET__Cb_KCPR6__"